import React from 'react';

const MAX_LENGTH = 500;

interface SuccessDefinitionStepProps {
  value: string | null;
  onChange: (value: string | null) => void;
}

const SuccessDefinitionStep: React.FC<SuccessDefinitionStepProps> = ({ value, onChange }) => {
  return (
    <div>
      <textarea
        rows={2}
        value={value ?? ''}
        onChange={e => onChange(e.target.value.slice(0, MAX_LENGTH) || null)}
        placeholder="e.g. 10 dentists in Miami I can email this week"
        className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition resize-none"
      />
      <p className="text-xs text-gray-400 mt-1.5 text-right">{(value ?? '').length}/{MAX_LENGTH}</p>
    </div>
  );
};

export default SuccessDefinitionStep;
